module.exports = __webpack_public_path__ + "src/img/pauseIcon.e899caaa.svg";